import { nameSpace } from './nameSpace';
import { createSliceWithName as dataGridSlice } from 'modules/dataGridTable/reducer';
import { createSelectors } from 'modules/dataGridTable/selectors';

export const moduleName = 'dataGridTable';
export const selectState = state => state[nameSpace][moduleName];

const initialState = {};

const dataGrid = dataGridSlice(`${nameSpace}/${moduleName}`, initialState);
// eslint-disable-next-line prefer-destructuring
export const reducer = dataGrid.reducer;
// eslint-disable-next-line prefer-destructuring
export const actions = dataGrid.actions;
export const selectors = createSelectors(selectState);
